import React from "react";

import Border from "../../Border";

import Collapsible from "react-collapsible";

import { IconAndSVGPicker } from "../../IconPickerGrid";
import ColorPicker from "../../ColorPicker";
import LinkSelect from "../../LinkSelect";

import PortalModal from "../PortalModal";

import Toggle from "../../sectioninputs/Toggle";
import { getIconType, getStandardIcon, getSVGIcon, isCombinedIconValue } from "../../constants/utils";

const COLORS = ["#FF6900", "#FCB900", "#7BDCB5"];

export default class Button extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: props.data,
      type: props.type,
      ccLinkType: props.ccLinkType,
      blockData: props.blockData
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState(nextProps);
  }

  _update(key, value) {
    let { data } = this.state;
    data[key] = value;

    if (key == "url" && (value.startsWith("/#") || value.startsWith("$#"))) {
      data.open_in_new_tab = false;
    }

    this.setState({ data });
    this.props.onUpdated(data);
  }

  _updateSetting(key, value) {
    let { data } = this.state;
    data.settings[key] = value;

    data.settings.msc_enabled = false;

    this.setState({ data });
    this.props.onUpdated(data);
  }

  _updateBadgeSetting(key, value) {
    let { data } = this.state;
    if (data.badge_settings == null) {
      data.badge_settings = {};
    }

    data.badge_settings[key] = value;

    data.badge_settings.msc_enabled = false;

    this.setState({ data });
    this.props.onUpdated(data);
  }

  _saveButtonIconValue(data, key, value) {
    if (isCombinedIconValue(data.icon)) {
      data.icon = getStandardIcon(data.icon) || "";
      data.icon_url = getSVGIcon(data.icon) || "";
      data.icon_type = getIconType(data.icon);
    }
    data[key] = value;
    if (key != "icon_type") {
      data.icon_type = key === "icon" ? "standard" : "svg";
    }
    this.setState({ data });
    this.props.onUpdated(data);
  }

  _renderIconPicker(data) {
    let iconValue = isCombinedIconValue(data.icon) ? data.icon : `${data.icon_type || "standard"}|${data.icon || ""}|${data.icon_images || ""}`;
    return <>
      <IconAndSVGPicker
          label="Default / Selected Icon"
          displayIconFontSize={30}
          displayIconClassName="color--dark"
          currentIcon={iconValue || ""}
          iconPickerColumnWidth={110}
          iconPickerClassName=""
          iconPickerWidth={356}
          iconPickerRowHeight={110}
          onSelected={(actionType, actionValue) => {
            if (actionType === "svg") {
              this._saveButtonIconValue(data, "icon_url", actionValue)
            } else if (actionType === 'type') {
              this._saveButtonIconValue(data, "icon_type", actionValue)
            } else {
              let value = ""
              if (actionValue.icon.startsWith("fa-")) {
                value = `${actionValue.icon} icon--lg`
              } else {
                value = "icon icon--lg icon-" + actionValue.name;
              }
              this._saveButtonIconValue(data, "icon", value)
              this.setState({ showIconPickerModal: false });
            }
          }}
      />
    </>
  }

  _renderModal(data, blockData) {
    const { type, ccLinkType } = this.state;

    return (
      <PortalModal
        show={this.props.showModal}
        onHide={() => this.props.onHide()}
      >
        <h2>Button Settings</h2>

        {this.props.showYoutubeURL ? (
          <>
            <Border>
              <Collapsible trigger="Video Source">
                <br></br>
                <select
                  value={data.extra?.video_source || "youtube"}
                  onChange={(event) => {
                    if(!data.extra) {
                      data.extra = {}
                    }

                    data.extra.video_source = event.target.value;

                    this.props.onUpdated(data);
                  }}
                >
                  <option value="youtube">YouTube</option>
                  <option value="vimeo">Vimeo</option>
                  <option value="wistia">Wistia</option>
                  <option value="rumble">Rumble</option>
                  <option value="jwp">JWP</option>
                  <option value="html">HTML5 Source</option>
                </select>
              </Collapsible>
            </Border>

            <Border>
              <Collapsible trigger="Video ID/URL">
                <br></br>
                <input
                  type="text"
                  defaultValue={data.url}
                  placeholder="jNQXAC9IVRw"
                  onChange={(event) => {
                    this._update("url", event.target.value);
                  }}
                />
              </Collapsible>
            </Border>

            {data.extra?.video_source === "rumble" && (
                <Border>
                  <Collapsible trigger="Pub Code">
                    <br />
                    <input
                        type="text"
                        defaultValue={data.extra?.rumble_pub_code || ""}
                        onChange={(event) => {
                          if (!data.extra) data.extra = {};
                          data.extra.rumble_pub_code = event.target.value;
                          this.props.onUpdated(data);
                        }}
                    />
                  </Collapsible>
                </Border>
            )}
          </>
        ) : (
          <Border>
            <Collapsible trigger="Button Link">
              <br></br>
              <span>Title</span>
              <input
                type="text"
                defaultValue={data.title}
                onChange={(event) => {
                  this._update("title", event.target.value);
                }}
              />

              <br />
              <br />

              <span>Link</span>
              <LinkSelect
                type={ccLinkType}
                url={data.url}
                onUpdated={(url, ccPageId) => {
                  data.url = url
                  data.cc_page_id = ccPageId
                  this.setState({ data }, () => this.props.onUpdated(data));
                }}
              />

              {!data.url?.startsWith("/#") && !data.url?.startsWith("$#") && (
                <>
                  <span>Open In New Tab</span>
                  <select
                    value={data.open_in_new_tab}
                    onChange={(event) => {
                      data.open_in_new_tab = event.target.value === "true";

                      this._update("open_in_new_tab", data.open_in_new_tab);
                    }}
                  >
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                  </select>
                </>
              )}
            </Collapsible>
          </Border>
        )}

        {type == "video" && (
          <Border>
            <Collapsible trigger="Video Size">
              <br></br>

              <select
                value={data.settings.overlay || "6"}
                onChange={(event) => {
                  this._updateSetting("overlay", event.target.value);
                }}
              >
                <option value="3">Small</option>
                <option value="6">Medium</option>
                <option value="9">Large</option>
              </select>
            </Collapsible>
          </Border>
        )}

        {!this.props.hideIcon && (
          <Border>
            <Collapsible trigger="Button Icon">
              <br></br>

              <Toggle
                id="button_icon_toggle"
                checked={data.icon != null}
                title="Enable Icon"
                onChange={(checked) => {
                  if (checked) {
                    this._update("icon", "icon icon--sm icon-Add-File");
                  } else {
                    const newData = { ...data };
                    newData.icon = null;
                    newData.icon_only = false;
                    this.setState({ data: newData });
                    this.props.onUpdated(newData);
                    if (blockData && this.props.onBlockUpdated) {
                      if(!blockData.extra) {
                        blockData.extra = {}
                      }
                      delete blockData.extra[data.id];
                      this.props.onBlockUpdated(blockData)
                    }
                  }
                }}
              />

              {
                ["primary", "secondary"].includes(type) && <Toggle
                  id="button_icon_only_toggle"
                  checked={data.icon_only || blockData?.extra?.[data.id] || false}
                  title="Icon Only"
                  onChange={(checked) => {
                    this._update("icon_only", checked);
                  }}
                />
              }

              {data.icon && this._renderIconPicker(data)}
            </Collapsible>
          </Border>
        )}

        <Border>
          <Collapsible trigger="Button Colors">
            <br></br>

            <ColorPicker
              title="Title Color"
              color={data.settings.primary_color}
              onColorSelected={(color) => {
                this._updateSetting("primary_color", color);
              }}
            />

            <br />
            {this._renderBackgroundColor(data)}
            {this._renderBorderColor(data)}
            {this._renderSecondaryColorSettings(data)}
          </Collapsible>
        </Border>

        {this._renderBadgeSettings(data)}
      </PortalModal>
    );
  }

  _renderBackgroundColor(data) {
    if (this.props.backgroundColor === false) {
      return null;
    }

    return (
      <>
        <ColorPicker
          title={this.props.backgroundColorTitle || "Background Color"}
          color={data.settings.secondary_color}
          onColorSelected={(color) => {
            this._updateSetting("secondary_color", color);
          }}
        />

        <br />
      </>
    );
  }

  _renderBorderColor(data) {
    if (this.props.borderColor === false) {
      return null;
    }

    return (
      <ColorPicker
        title="Border Color"
        color={data.settings.tertiary_color}
        onColorSelected={(color) => {
          this._updateSetting("tertiary_color", color);
        }}
      />
    );
  }

  _renderSecondaryColorSettings(data) {
    if (!this.props.secondaryColorsTitle) {
      return null;
    }

    let titleClassName = this.props.secondaryColorsSubtitle ? "mb-0" : "";

    return (
      <>
        {this.props.secondaryColorsSubtitle && (
          <label className="mt-3 mb-3">
            {this.props.secondaryColorsSubtitle}
          </label>
        )}
        {this._renderColor(
          "quaternary_color",
          "quaternaryColorTitle",
          "Title Color (On Sticky Nav Bar)",
          data
        )}
        {this._renderColor(
          "quinary_color",
          "quinaryColorTitle",
          "Background Color (On Sticky Nav Bar)",
          data
        )}
        {this._renderColor(
          "senary_color",
          "senaryColorTitle",
          "Border Color (On Sticky Nav Bar)",
          data
        )}
      </>
    );
  }

  _renderColor(colorKey, titleKey, defaultTitle, data) {
    if (this.props[titleKey] === false) {
      return null;
    }

    return (
      <>
        <ColorPicker
          title={this.props[titleKey] || defaultTitle}
          color={data.settings[colorKey]}
          onColorSelected={(color) => {
            this._updateSetting(colorKey, color);
          }}
        />

        <br />
      </>
    );
  }

  _renderBadgeSettings(data) {
    if (this.props.badge === false) {
      return null;
    }

    return (
      <Border>
        <Collapsible trigger="Button Badge Option">
          <br></br>

          <Toggle
            id="button_badge_toggle"
            checked={data.badge != null}
            title="Enable Badge"
            onChange={(checked) => {
              if (checked) {
                this._update("badge", "Badge");
              } else {
                this._update("badge", null);
              }
            }}
          />

          {data.badge && (
            <>
              <span>Title</span>
              <input
                type="text"
                defaultValue={data.badge}
                onChange={(event) => {
                  if (event.target.value) {
                    this._update("badge", event.target.value);
                  } else {
                    this._update("badge", null);
                  }
                }}
              />

              <br />
              <br />

              <ColorPicker
                title="Title Color"
                color={
                  data.badge_settings ? data.badge_settings.primary_color : null
                }
                onColorSelected={(color) => {
                  this._updateBadgeSetting("primary_color", color);
                }}
              />

              <br />

              <ColorPicker
                title="Background Color"
                color={
                  data.badge_settings
                    ? data.badge_settings.tertiary_color
                    : null
                }
                onColorSelected={(color) => {
                  this._updateBadgeSetting("tertiary_color", color);
                }}
              />
            </>
          )}
        </Collapsible>
      </Border>
    );
  }

  render() {
    let { data, blockData } = this.state;
    return (
      <>
        <a onClick={() => this.setState({ showModal: true })}>
          <div className="edit edit-button">
            <i className="icon icon--xs icon-Pencil edit-button-i" />
          </div>
        </a>

        {this._renderModal(data, blockData)}
      </>
    );
  }
}
